import React from 'react';

import { Image } from '@vw-marketing/us-components';

import { onVWBasicButtonClickWithProcessEvent } from '../../../../shared/tagging/tagging-helpers';
import { StyledAppButtonCTA } from './styled';

interface AppButtonViewProps {
  image: string;
  link: string;
  type: 'GOOGLE_PLAY' | 'APP_STORE';
  trackingManager: any;
}

const AppButtonView = ({ link, image, type, trackingManager }: AppButtonViewProps) => {
  const handleClick = () => {
    try {
      const buttonName = type == 'APP_STORE' ? 'App Store' : 'Google Play';
      onVWBasicButtonClickWithProcessEvent(
        trackingManager,
        {
          Name: 'Vehicle Management',
          StepName: 'Vehicle Details - Add Vehicle',
          StepNumber: '5.3',
        },
        { name: buttonName },
      );
    } catch (error) {
      console.warn('Error tracking app button click:', error);
    }
  };

  return (
    <StyledAppButtonCTA emphasis="tertiary" href={link} target="_blank" onClick={handleClick}>
      <Image className="badge-images" src={image} alt="app-store-button" srcPlaceholder="" />
    </StyledAppButtonCTA>
  );
};

export default AppButtonView;
